module.exports = __webpack_public_path__ + "static/media/icn-remove.24b05b26.svg";